import { opportunityFilterReducer } from './opportunityFilters';
import { reportsFilterReducer } from './reportsFilters';
import { combineReducers } from 'redux';
import { changeLanguageReducer } from './translationChange';
import { talentFilterReducer } from './talentFilters';
import { parecerTecnicoReducer } from './parecerTecnico';
import { parecerComportamentalReducer } from './parecerComportamental';
import { eventFilter } from './eventFilter';
import { shortlistUpdateReducer } from './shortlistUpdate';

export const Reducers = combineReducers({
  reportsFilterReducer: reportsFilterReducer,
  opportunityFilterReducer: opportunityFilterReducer,
  talentFilterReducer: talentFilterReducer,
  changeLanguageReducer: changeLanguageReducer,
  parecerTecnicoReducer: parecerTecnicoReducer,
  parecerComportamentalReducer: parecerComportamentalReducer,
  eventFilterReducer: eventFilter,
  shortlistUpdateReducer: shortlistUpdateReducer,
});